import {
  fetchWrapper,
  handleResponse,
  formatBody,
  hcUrlV3,
  buildOpts,
} from 'services/RequestService/helpers';

const idMeVerification = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrlV3('/id_me_verify'),
    buildOpts({
      method: 'POST',
      body: formatBody({ token: params.token }),
    })
  );
  return handleResponse(response);
};

export { idMeVerification };
